import React from "react";
import { Route, Routes } from "react-router-dom";

import "./App.css";
import { HomePage } from "./pages/home.page";
import { ApplicationProviders } from "./config/app-providers";
import { Layout } from "./layout/layout";
import { WebhooksPage } from "./pages/webhooks.page";
import { MagicEventsPage } from "./pages/magic-events.page";
import { DeadLettersPage } from "./pages/dead-letters.page";
import { RecordMatchingPage } from "./pages/record-matching.page";
import { GuestIdentityDetailsPage } from "./pages/guest-identity-details.page";
import { ConflictResolutionPage } from "./pages/conflict-resolution.page";
import { ApiDocsPage } from "./pages/api-docs.page";
import { Manifest } from "./components/manifest";

const App = () => (
  <ApplicationProviders>
    <Manifest />
    <Layout>
      <Routes>
        <Route path="/webhooks" element={<WebhooksPage />} />
        <Route path="/magic-events" element={<MagicEventsPage />} />
        <Route path="/dead-letters" element={<DeadLettersPage />} />
        <Route path="/private-api-doc" element={<ApiDocsPage />} />
        <Route
          path="/record-matching/guest-identities/:guestIdentityId"
          element={<GuestIdentityDetailsPage />}
        ></Route>
        <Route
          path="/record-matching/conflict-resolution/:personId"
          element={<ConflictResolutionPage />}
        />
        <Route path="/record-matching" element={<RecordMatchingPage />} />
        <Route path="/" element={<HomePage />} />
      </Routes>
    </Layout>
  </ApplicationProviders>
);

export default App;
